/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navigation_Search_TipInputs */



/**
* | output |
* | --- |
* | "Use arrow keys to navigate, Enter to select" |
*
* @param {Navigation_Search_TipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const navigation_search_tip = /** @type {((inputs?: Navigation_Search_TipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navigation_Search_TipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwende die Pfeiltasten zum Navigieren, Enter zum Auswählen")
	return /** @type {LocalizedString} */ ("Use arrow keys to navigate, Enter to select")
});